/**
 * Single private word for every gated page: /join (founder story) and the
 * preorder pages (/preorder, /preorder/**). Sent to invited leads by email
 * (links carry ?code= or #word) and never prefilled. Gated content renders
 * client-side only after unlock, so it is absent from the server HTML.
 */
export const PRIVATE_ACCESS_WORD = 'heels'
export const PREORDER_ACCESS_WORD = PRIVATE_ACCESS_WORD
export const PREORDER_ACCESS_STORAGE_KEY = 'kendrick-preorder-access'
/** Session key set by the /join gate; the same word opens the preorder pages. */
export const FOUNDER_STORY_ACCESS_STORAGE_KEY = 'kendrick-founder-story-access'

export const isPreorderAccessCode = (value: unknown) =>
  typeof value === 'string' && value.trim().toLowerCase() === PREORDER_ACCESS_WORD

/** True when this browser session already unlocked, or the URL carries the code. */
export function readPreorderAccess(queryCode?: unknown): boolean {
  if (typeof window === 'undefined') return false
  try {
    if (isPreorderAccessCode(queryCode)) {
      window.sessionStorage.setItem(PREORDER_ACCESS_STORAGE_KEY, 'granted')
      // Drop the word from the address bar so a shared link does not carry it.
      const url = new URL(window.location.href)
      url.searchParams.delete('code')
      window.history.replaceState(window.history.state, '', url.toString())
      return true
    }
    // Same word everywhere: an unlock on /join also opens the preorder pages.
    return window.sessionStorage.getItem(PREORDER_ACCESS_STORAGE_KEY) === 'granted'
      || isPreorderAccessCode(window.sessionStorage.getItem(FOUNDER_STORY_ACCESS_STORAGE_KEY))
  } catch {
    return false
  }
}
